import { Typography } from 'antd';
import React, { useEffect } from 'react';

import UpdatedAt from '../components/updated-at';

export function getUpdatedAtMessage(
  wasUpdated: boolean,
  updatedAt: number | undefined,
): React.ReactElement {
  return (
    <Typography>
      {wasUpdated ? <UpdatedAt value={updatedAt} /> : 'Not updated yet!'}
    </Typography>
  );
}

export function renderUpdatedAtMessage(
  updatedAt: number | undefined,
  inProcess: boolean,
  condition: () => boolean,
): React.ReactElement {
  const [wasUpdated, setWasUpdated] = React.useState(false);

  useEffect((): void => {
    if (condition() && updatedAt) {
      setWasUpdated(true);
    }
  }, [updatedAt, condition, inProcess]);

  return getUpdatedAtMessage(wasUpdated, updatedAt);
}
